<div class="details-card-wrapper">
    <h2>Highlights</h2>

    <div class="details-card">
        <div class="details-card-body">
            <ol class="hightlights-list">
                @for (highlight of highlightsToShow(); track highlight) {
                <li>
                    {{ highlight }}
                </li>
                }
            </ol>

            <!-- View More Section -->
            @if (hasMoreHighlights()) {
            <div class="view-more-section d-flex flex-row justify-content-end">
                <div class="view-more-content">
                    @if (!isExpanded) {
                    <span (click)="toggleViewMoreComments()" class="view-more">View More Highlights</span>
                    } @if (isExpanded) {
                    <span (click)="toggleViewMoreComments()" class="view-more">View Less Highlights</span>
                    }
                </div>
            </div>
            }
        </div>
    </div>
</div>